import { useCallback } from 'react';

import { type Comment } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type BaseEditCommentParams } from '../types';
import META from './useTrackAddedComment.meta';

export type CommentTime = 'time_range' | 'timestamp' | 'none';

export type AddedComment = BaseEditCommentParams & {
  comment: Comment['body'];
  comment_time: CommentTime;
  startedDiscussion: boolean;
};

export const useTrackAddedComment = () => {
  const { track } = useAnalyticsUtilities();

  const trackAddedComment = useCallback(
    (params: AddedComment) => {
      track(META.name, params, { integrations: { Intercom: true } });
    },
    [track],
  );

  return { trackAddedComment };
};
